import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// faGasPump, faSquareParking, faArrowRightFromBracket, faArrowRightToBracket
const WaypointIcons = ({type}) => {
    const getIcon = (type) => {
        switch (type) {
            case "p":
                return <FontAwesomeIcon icon="square-parking" className="fa-xl"/>
            case "g":
                return <FontAwesomeIcon icon="gas-pump" className="fa-xl"/>
            case "t":
                return <FontAwesomeIcon icon="screwdriver-wrench" className="fa-xl"/>
            case "r":
                return <FontAwesomeIcon icon="recycle" className="fa-xl"/>
            default:
                return <></>
        }
    }
    return getIcon(type)
}
export default WaypointIcons